module.exports = __webpack_public_path__ + "fonts/iconfont.e2620b15.ttf";